import { Link } from "react-router-dom";
import { IMG } from "@/data/site";

export const Logo = ({ className = "" }) => (
  <Link to="/" data-testid="logo-home-link" className={`flex items-center gap-3 ${className}`}>
    <img
      src={IMG.logo}
      alt="Super 8 by Wyndham Ottawa, Kansas logo"
      className="h-16 w-auto md:h-20"
      width="80"
      height="80"
    />
    <span className="hidden flex-col leading-none sm:flex">
      <span className="font-heading text-base font-black uppercase tracking-tight text-charcoal">Ottawa</span>
      <span className="font-body text-[10px] uppercase tracking-[0.25em] text-fog">Kansas · Off I-35</span>
    </span>
  </Link>
);
